<script>
import { uuidv4 } from '@/utils'

export default {
  props: {
    id: { type: String, default: uuidv4() },
    value: { type: Array, required: true, default: () => [] },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'default' },
  },
  data() {
    return {
      ref: `LadTags-${this.id}`,
      base: 'components.lad_tags',
    }
  },
}
</script>
